import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import Footer from "../Component/Footer";
import defaultfullbanner from "../Component/img/event1.jfif"; // Import the default banner image
import defaultlogo from "../Component/img/profile.webp";
import {
  ExternalLink,
  LogOut as UsersIcon,
  Star,
  MapPin,
  Radio,
} from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXTwitter,
  faLinkedinIn,
  faFacebookF,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons"; 
import FollowEvent from "../Component/FollowEvent";
import PageViewCount from "../Component/PageViewCount";
import EventExhibitor from "../Component/EventExhibitor";
import EventSponsor from "../Component/EventSponsor";
import EventPartner from "../Component/EventPartner";
import EventSpeaker from "../Component/EventSpeaker";
import OrgQuery from "../Component/OrgQuery";
import { Link, useNavigate } from "react-router-dom";
import RegNow from "../Component/RegNow";
import RatingReview from "../Component/RatingReview";
import { Helmet } from 'react-helmet';


const Sport = () => {
  const { slug } = useParams();

  const navigate = useNavigate(); // Hook for navigation
  const [userId, setUserId] = useState(null);

  // State initialization
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [selectedHighlightes, setSelectedHighlightes] = useState([]);
  const [selectedTimeline, setSelectedTimeline] = useState([]);
  const [selectedExhibitor, setSelectedExhibitor] = useState([]);
  const [selectedSponsor, setSelectedSponsor] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState([]);
  const [selectedSpeaker, setSelectedSpeaker] = useState([]);
  const [selectedForms, setSelectedForms] = useState([]);
  const [selectedFollower, setSelectedFollower] = useState(null);
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}getSportBySlug/${slug}`
        );

        const {
          sport,
          industries,
          forms,
          highlights,
          eventTimes,
          exhibitors,
          sponsors,
          partners,
          speakers,
          followCount,
          reviews,
        } = response.data;

        setEventData(response.data.sport);
        setSelectedIndustries(industries.map((industry) => industry.industry));
        setSelectedHighlightes(
          highlights.map((highlight) => highlight.highlight)
        );
        // Map timeline strings from eventTimes
        // setSelectedTimeline(eventTimes.map((event) => event.timeline));
        setSelectedTimeline(eventTimes);
        setSelectedExhibitor(exhibitors);
        setSelectedSponsor(sponsors);
        setSelectedPartner(partners);
        setSelectedSpeaker(speakers);
        setSelectedForms(forms);
        setSelectedFollower(followCount);
        // console.log("exhibitors", exhibitors);
        setReviews(reviews);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching event details", error);
        setLoading(false);
      }
    };

    fetchEventDetails();
  }, [slug]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "2-digit",
    });
  };

  // Handle loading state
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <span className="loader"></span>
        <p className="ms-3">Loading Content...</p>
      </div>
    );
  }

  return (
    <>


<Helmet>
        <link rel="canonical" href={`https://evventoz.com/${eventData.sport_name}/sport`} />
        <title>{eventData.sport_name}</title>
      </Helmet>


      

      <NavbarVisitor />
      <PageViewCount eventUniqueId={eventData.sport_unique_id} />
      <div className="" style={{ backgroundColor: "#f3f3f3" }}>
        <div className="col-md-12">
          <div className="eventcard_container bg-white p-1 bdrds">
            <div className="">
              <img
                src={
                  eventData?.eventfullbanner
                    ? `${IMAGE_URL}sportFiles/${eventData.eventfullbanner}`
                    : defaultfullbanner
                } // Use imported default banner
                className="img-fluid evntfullban vntbanr"
                alt={eventData.sport_name}
              />
            </div>
          </div>
        </div>

        <div className="container">
          <div className="mt-3">
            <div className="row">
              <div className="col-md-8 text-start">
                <div className="bg-white p-2 rounded mb-3">
                  <div className="times">
                    {formatDate(eventData.sport_start_date)} -{" "}
                    {formatDate(eventData.sport_end_date)}
                  </div>
                  <h1 className="ename">{eventData.sport_name}</h1>
                  <div className=" ">
                    <div>
                      <p className="">
                                              <a href="#ratings">
                                                <span className="ft13 text-muted">
                                                  {reviews && reviews.averageRating ? (
                                                    <>
                                                      {/* Render stars dynamically */}
                                                      {[...Array(5)].map((_, index) => {
                                                        const rating = reviews.averageRating;
                                                        if (index + 1 <= Math.floor(rating)) {
                                                          // Full star
                                                          return (
                                                            <FontAwesomeIcon
                                                              key={index}
                                                              icon={faStar}
                                                              className="text-success"
                                                            />
                                                          );
                                                        } else if (index < rating) {
                                                          // Half star
                                                          return (
                                                            <FontAwesomeIcon
                                                              key={index}
                                                              icon={faStarHalfAlt}
                                                              className="text-success"
                                                            />
                                                          );
                                                        } else {
                                                          // Empty star
                                                          return (
                                                            <FontAwesomeIcon
                                                              key={index}
                                                              icon={faStar}
                                                              className="empty-star " // Use empty-star class here for styling
                                                            />
                                                          );
                                                        }
                                                      })}
                                                      {/* Display the average rating and review count */}
                                                      <span className="ft13 text-muted ms-2">
                                                        {`${reviews.averageRating.toFixed(1)} (${
                                                          reviews.reviewCount
                                                        } Ratings)`}
                                                      </span>
                                                    </>
                                                  ) : (
                                                    // No ratings yet, show 5 empty stars
                                                    <>
                                                      {[...Array(5)].map((_, index) => (
                                                        <FontAwesomeIcon
                                                          key={index}
                                                          icon={faStar}
                                                          className="empty-star text-succsss"
                                                        />
                                                      ))}
                                                      <span>(0 Rating)</span>
                                                    </>
                                                  )}
                                                </span>
                                              </a>
                                            </p>

                      {eventData.venue_address && (
                        <a href="#venue">
                        <p className="">
                          <span className="ft13 text-muted">
                            <MapPin size={17} />
                          </span>{" "}
                          <span className="ft13 text-muted">
                            {eventData.venue_address}
                          </span>
                        </p>
                        </a>
                      )}

                      <p className="">
                        <span className="ft13 text-muted">
                          <Radio size={17} />
                        </span>{" "}
                        <span className="ft13 text-muted">
                          {eventData.format
                            ? eventData.format === "Exhibitionsport"
                              ? "Exhibition + sport"
                              : eventData.format
                            : "sport"}
                        </span>
                      </p>

                      <div className="text-start cattext mb-2 text-muted">
                        {selectedIndustries.map((industry, index) => (
                          <span
                            key={index}
                            className="industry-item"
                            style={{
                              marginRight: "5px",
                            }}
                          >
                            #{industry}
                          </span>
                        ))}
                      </div>

                      <div className="d-flex align-items-center">
                        <div>
                          <span>
                            <img
                              src={defaultlogo}
                              className="imgfluid folimg"
                            />
                          </span>
                          <span>
                            <img
                              src={defaultlogo}
                              className="imgfluid folimg folimg2"
                            />
                          </span>
                          <span>
                            <img
                              src={defaultlogo}
                              className="imgfluid folimg folimg2"
                            />
                          </span>
                          <span>
                            <img
                              src={defaultlogo}
                              className="imgfluid folimg folimg2"
                            />
                          </span>
                          <span>
                            <img
                              src={defaultlogo}
                              className="imgfluid folimg folimg2"
                            />
                          </span>
                          <span>
                            <img
                              src={defaultlogo}
                              className="imgfluid folimg folimg2"
                            />
                          </span>
                        </div>
                        <div className="followers2">
                          {selectedFollower} Followers
                        </div>
                      </div>
                      <div>
                        <FollowEvent
                          eventUniqueId={eventData.sport_unique_id}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <img
                    src={
                      eventData.eventbanner
                        ? `${IMAGE_URL}sportFiles/${eventData.eventbanner}`
                        : defaultfullbanner
                    }
                    className="img-fluid imgevnt"
                    alt="Event"
                  />
                </div>

                <div className="p-3 bg-white rounded">
                  <h3 className="h3clsss">Organised By</h3>

                  <div className="">
                    <div className="svgorg">
                      <svg viewBox="0 0 40 40" fill="none" className="svgorg">
                        <circle cx="20" cy="20" r="20" fill="#BBC4DB"></circle>
                        <path
                          d="M32.116 35.863C36.908 32.21 40 26.441 40 19.95 40 12.806 36.255 6.537 30.622 3 21.153 3.522 8 8.04 8 13.838c0 3.72 4.614 4.755 9.022 5.745 2.904.651 5.718 1.283 7.068 2.648 1.263 1.278.745 3.5.212 5.79-.902 3.87-1.848 7.928 5.698 7.928.713 0 1.419-.029 2.116-.086z"
                          fill="#5F73A7"
                        ></path>
                      </svg>
                      &nbsp;By <strong>{eventData.organised_by}</strong>
                    </div>
                    {/* <p>
                      Experience classic style at the India Jewellery Show,
                      where each piece is crafted to make you the ideal bride.
                      Discover the creativity, genius, and unparalleled
                      workmanship that characterize your special day. teste
                    </p> */}
                    <div className="mt-3">
                      <OrgQuery eventid={eventData.sport_unique_id} />
                    </div>
                  </div>
                </div>

                <div className="mt-3 mb-3 bg-white p-3 rounded  ">
                  <p className="text-justify mb-3">
                    {eventData.sport_description ||
                      "No description available for this event."}
                  </p>

                  {selectedHighlightes && selectedHighlightes.length > 0 && (
                    <div className="highlight-container">
                      <h3 className="h3clsss">Highlights</h3>
                      <div>
                        {selectedHighlightes.map((highlight, index) => (
                          <li
                            key={index}
                            className="highlight-item"
                            style={{
                              marginRight: "5px",
                            }}
                          >
                            {highlight}
                          </li>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="text-start">
                  <h3 className="h3clsss">Share On</h3>
                  <div>
                    <span className="tagcs fbbg me-2">
                      <FontAwesomeIcon
                        icon={faFacebookF}
                        className="text-white"
                      />
                    </span>
                    <span className="tagcs whatappbg me-2">
                      <FontAwesomeIcon
                        icon={faWhatsapp}
                        className="text-white"
                      />
                    </span>
                    <span className="tagcs linkedinbg me-2">
                      <FontAwesomeIcon
                        icon={faLinkedinIn}
                        className="text-white"
                      />
                    </span>
                    <span className="tagcs xbg me-2">
                      <FontAwesomeIcon
                        icon={faXTwitter}
                        className="text-white"
                      />
                    </span>
                  </div>
                </div>

                <div className="mt-3   p-3 mb-3 bg-white rounded mb-3">
                  <div className="row mb-2">
                    <div className="col-md-6 mb-2">
                      <h3 className="h3clsss mb-0">Dates & Timings</h3>

                      <div>
                        <div>
                          {selectedTimeline.map((timeline, index) => {
                            // Format selected_date to "12 Jan, 24"
                            const formattedDate = new Date(
                              timeline.selected_date
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "2-digit",
                            });

                            // Helper function to convert time to 12-hour format
                            const formatTime = (time) => {
                              const [hours, minutes] = time
                                .split(":")
                                .map(Number);
                              const period = hours >= 12 ? "PM" : "AM";
                              const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
                              return `${formattedHours}:${minutes
                                .toString()
                                .padStart(2, "0")} ${period}`;
                            };

                            return (
                              <p
                                key={index}
                                className=""
                                style={{
                                  marginRight: "5px",
                                }}
                              >
                                {formattedDate} [{" "}
                                {formatTime(timeline.start_time)} -{" "}
                                {formatTime(timeline.end_time)} ]{" "}
                                {timeline.timezone === "+05:30"
                                  ? "IST"
                                  : timeline.timezone}
                              </p>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <h3 className="h3clsss mb-0">Event Type</h3>
                      <p>
                        {eventData.format
                          ? eventData.format === "Exhibitionsport"
                            ? "Exhibition + sport"
                            : eventData.format
                          : "sport"}
                      </p>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-6 mb-2">
                      <h3 className="h3clsss mb-0">Frequency</h3>
                      <p>{eventData.sport_frequency}</p>
                    </div>
                    <div className="col-md-6 mb-2">
                      <h3 className="h3clsss mb-0">Event Mode</h3>
                      <p>
                        {eventData.event_mode === "inPerson"
                          ? "In-Person"
                          : eventData.event_mode === "virtual"
                          ? "Virtual"
                          : "In-Person"}
                      </p>
                    </div>
                  </div>

                  <div className="row mb-2" id="venue">
                    <div className="col-md-6 mb-2"></div>
                    <div className="col-md-6 mb-2">
                      {eventData.sport_website !== "" ? (
                        <>
                          <h3 className="h3clsss mb-0">Official Link</h3>
                          <div className="col">
                            <p>
                              {/* {eventData.sport_website} */}
                              {"  "}
                              <a
                                href={eventData.sport_website}
                                target="_blank"
                              >Website
                                <ExternalLink className="ic" size={20} />
                              </a>
                            </p>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="mt-3 bg-white rounded mb-3 p-3">
                  <h2 className="h3clsss text-start mb-2">
                    Venue Map & Direction
                  </h2>

                  <hr className="mb-2" />

                  <div className="row">
                    <div className="col-md-8">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: (() => {
                            // Check if eventData.venue_map is available
                            if (eventData.venue_map) {
                              // Replace width and height if they exist
                              let updatedMap = eventData.venue_map;

                              // Replace width if present
                              updatedMap = updatedMap.replace(
                                /width="\d+"/,
                                'width="100%"'
                              );

                              // Replace height if present
                              updatedMap = updatedMap.replace(
                                /height="\d+"/,
                                'height="200"'
                              );

                              return updatedMap; // Return the modified string
                            }
                            return ""; // Return an empty string if venue_map is not available
                          })(),
                        }}
                      />
                    </div>

                    <div className="col-md-4 text-start">
                      <p className="reviewcs">
                        <strong>{eventData.venue_name}</strong>
                      </p>
                      <p className="reviewcs11">{eventData.venue_address}</p>

                      {(() => {
  const match = eventData.venue_map?.match(/!2d([\d.]+)!3d([\d.]+)/);
  const lat = match ? match[2] : null;
  const lng = match ? match[1] : null;

  const mapUrl = lat && lng
    ? `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
    : null;

  return mapUrl ? (
    <a href={mapUrl} target="_blank" rel="noopener noreferrer">
      <button className="btn bg-gradient-primary text-white btn-sm">
        Get Direction
      </button>
    </a>
  ) : null;
})()}


                    </div>
                  </div>

                  <div>
                    {/* <RatingComp eventUniqueId={eventData.event_unique_id} />
                  <EventAgenda eventUniqueId={eventData.event_unique_id} /> */}
                  </div>
                </div>

                <div>
                   
                  {selectedSponsor && selectedSponsor.length > 0 && (
                    <EventSponsor
                      sponsors={selectedSponsor}
                      slug={eventData.sport_slug}
                      type="sport"
                      selectedForms={selectedForms}
                      eventUniqueId={eventData.sport_unique_id}
                    />
                  )}

                  {selectedPartner && selectedPartner.length > 0 && (
                    <EventPartner
                      partners={selectedPartner}
                      slug={eventData.sport_slug}
                      type="sport"
                      selectedForms={selectedForms}
                      eventUniqueId={eventData.sport_unique_id}
                    />
                  )}

                  <div id="ratings"></div>

                  {selectedSpeaker && selectedSpeaker.length > 0 && (
                    <EventSpeaker
                      speakers={selectedSpeaker}
                      slug={eventData.sport_slug}
                      type="sport"
                      selectedForms={selectedForms}
                      eventUniqueId={eventData.sport_unique_id}
                    />
                  )}
                </div>

                <div>
                  <RatingReview
                    eventUniqueId={eventData.sport_unique_id}
                    slug={eventData.sport_slug}
                    type="sport"
                    
                  />
                </div>
              </div>

              <div className="col-md-4"> 
                 
                  <RegNow
                    selectedForms={selectedForms}
                    eventUniqueId={eventData.sport_unique_id}
                    type="sport"
                  />
                 
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Sport;
